import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { labRequestCalendaredRecord } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTCALENDAR,
  DELETE_LABREQUESTCALENDAR,
  GET_LABREQUESTCALENDARS,
  UPDATE_LABREQUESTCALENDAR
} from "./actionTypes";
import {
  addLabRequestCalendarFail,
  addLabRequestCalendarSuccess,
  deleteLabRequestCalendarFail,
  deleteLabRequestCalendarSuccess,
  getLabRequestCalendarsFail,
  getLabRequestCalendarsSuccess,
  setState,
  updateLabRequestCalendarFail,
  updateLabRequestCalendarSuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestCalendars( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, labRequestCalendaredRecord, params.toString());
    yield put(setState(false))
    yield put(getLabRequestCalendarsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestCalendarsFail(error));
  }
}

function* updateLabRequestCalendar ({payload: labRequestCalendarObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestCalendarObj;
    yield call(patchApiCall, `${labRequestCalendaredRecord}/${id}`, rest);
    const response = yield call(getTable,`${labRequestCalendaredRecord}/${labRequestCalendarObj.id}`);
    yield put(updateLabRequestCalendarSuccess(response));
  } catch (error) {
    yield put(updateLabRequestCalendarFail(error));
  }
}

function* deleteLabRequestCalendar ({payload: labRequestCalendarObj}) {
  try {
    yield call(deleteApiCall,`${labRequestCalendaredRecord}/${labRequestCalendarObj.id}` );
    yield put(deleteLabRequestCalendarSuccess(labRequestCalendarObj.id));
  } catch (error) {
    yield put(deleteLabRequestCalendarFail(error));
  }
}

function* postingLabRequestCalendar ({ payload: labRequestCalendar}) {
  try {
    const response = yield call(postApiCall, labRequestCalendaredRecord ,labRequestCalendar);
    const response1 = yield call(getTable,`${labRequestCalendaredRecord}/${response.id}`);
    yield put(addLabRequestCalendarSuccess(response1));
  } catch (error) {
    yield put(addLabRequestCalendarFail(error));
  }
}

function* labRequestCalendarsSaga() {
  yield takeEvery(GET_LABREQUESTCALENDARS, fetchLabRequestCalendars);
  yield takeEvery(ADD_NEW_LABREQUESTCALENDAR, postingLabRequestCalendar);
  yield takeEvery(UPDATE_LABREQUESTCALENDAR, updateLabRequestCalendar);
  yield takeEvery(DELETE_LABREQUESTCALENDAR, deleteLabRequestCalendar);
}

export default labRequestCalendarsSaga;
